import { createAsyncThunk } from '@reduxjs/toolkit';
import * as api from '@/lib/api/activities';
import {
  CloseActivityRequest,
  QueryManagerQueueFilters,
  RaiseQueryRequest,
} from '@/types/activity';

export const fetchQueueActivities = createAsyncThunk(
  'activity/fetchQueue',
  async (filters: QueryManagerQueueFilters) => api.getQueryManagerQueue(filters),
);

export const fetchActivitiesSummary = createAsyncThunk(
  'activity/fetchSummary',
  async () => api.getActivitiesSummary(),
);

export const fetchCaseActivities = createAsyncThunk(
  'activity/fetchForCase',
  async (caseId: number) => api.getCaseActivities(caseId),
);

export const raiseQuery = createAsyncThunk(
  'activity/raiseQuery',
  async ({ caseId, payload }: { caseId: number; payload: RaiseQueryRequest }) =>
    api.raiseQuery(caseId, payload),
);

export const closeActivity = createAsyncThunk(
  'activity/close',
  async ({ activityId, payload }: { activityId: number; payload: CloseActivityRequest }) =>
    api.closeActivity(activityId, payload),
);

export const clearBadge = createAsyncThunk(
  'activity/clearBadge',
  async (activityId: number) => {
    await api.clearActivityBadge(activityId);
    return activityId;
  },
);

export const uploadAttachment = createAsyncThunk(
  'activity/uploadAttachment',
  async ({ activityId, file }: { activityId: number; file: File }) => api.uploadAttachment(activityId, file),
);
